<template>
  <div>
    <h4>Basic Setting</h4>
    <el-card>
      <el-form-item v-if="showSearchBy" label="Group by">
        <el-radio-group v-model="searchByRadio" size="mini">
          <el-radio-button label="asCustomers">As Customers</el-radio-button>
          <el-radio-button label="asProducts">As Products</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Date Range">
        <el-radio-group
          v-if="showDateRangeRadio"
          v-model="dateTypeRadio"
          size="mini"
          class="radio-container"
        >
          <el-radio-button label="date">Date</el-radio-button>
          <el-radio-button label="dueDate">Due Date</el-radio-button>
          <el-radio-button v-if="showDeliveryDate" label="deliveryDate">ETA Date</el-radio-button>
        </el-radio-group>

        <el-date-picker
          v-model="dateRangePicker"
          type="daterange"
          range-separator="-"
          start-placeholder="From"
          end-placeholder="To"
          format="dd MMM yyyy"
          value-format="yyyy-MM-dd"
          size="mini"
          :style="showDateRangeRadio ? 'margin-left: 20px' : ''"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="Sheet Tag">
        <el-checkbox v-model="checkTagAll">ALL</el-checkbox>
        <el-checkbox-group v-model="checkedTags" v-show="!checkTagAll" size="mini">
          <el-checkbox-button v-for="item in invTags" :label="item" :key="item.value">{{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Warehouse">
        <el-checkbox v-model="checkWarehouseAll">ALL</el-checkbox>
        <el-checkbox-group v-show="!checkWarehouseAll" v-model="checkedWarehouses" size="mini">
          <el-checkbox-button
            v-for="item in warehouses"
            :label="item"
            :key="item.value"
          >{{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Include Cost">
        <el-radio-group v-model="includeCostRadio" size="mini">
          <el-radio-button :label="false">No</el-radio-button>
          <el-radio-button :label="true">Yes</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'ReportBasicSetting',
  created () {
    this.setGroupBy('asCustomers')
    this.setDateType('date')
    console.log(this.type)
  },
  props: {
    showDeliveryDate: {
      type: Boolean,
      default: true
    },
    showDateRangeRadio: {
      type: Boolean,
      default: true
    },
    showSearchBy: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('report', [
      'type',
      'groupBy',
      'dateType',
      'dateRange',
      'tagAll',
      'selectedTags',
      'selectedWh',
      'warehouseAll',
      'includeCost'
    ]),
    ...mapState(['warehouses']),
    ...mapGetters({
      invTags: 'invoiceTags'
    }),
    searchByRadio: {
      get () {
        return this.groupBy
      },
      set (val) {
        this.setGroupBy(val)
      }
    },
    dateTypeRadio: {
      get () {
        return this.dateType
      },
      set (val) {
        this.setDateType(val)
      }
    },
    dateRangePicker: {
      get () {
        return this.dateRange
      },
      set (val) {
        this.setDateRange(val)
      }
    },
    checkTagAll: {
      get () {
        return this.tagAll
      },
      set (val) {
        this.setTagAll(val)
        if (!val) {
          this.setTags([])
        }
      }
    },
    checkedTags: {
      get () {
        return this.selectedTags
      },
      set (val) {
        this.setTags(val)

        if (this.selectedTags.length === this.invTags.length) {
          this.setTagAll(true)
        }
      }
    },
    checkWarehouseAll: {
      get () {
        return this.warehouseAll
      },
      set (val) {
        this.setWarehoueAll(val)
        if (!val) {
          this.setWarehouses([])
        }
      }
    },
    checkedWarehouses: {
      get () {
        return this.selectedWh
      },
      set (val) {
        this.setWarehouses(val)
        if (this.selectedWh.length === this.warehouses.length) {
          this.setWarehoueAll(true)
        }
      }
    },
    includeCostRadio: {
      get () {
        return this.includeCost
      },
      set (val) {
        this.setIncludeCost(val)
      }
    }
    // qtyCriterion: {
    //   get () {
    //     return this.qtyCriterion
    //   },
    //   set (val) {
    //     this.setQtyCriterion(val)
    //   }
    // }
  },
  methods: {
    ...mapMutations({
      setGroupBy: 'report/setGroupBy',
      setDateType: 'report/setDateType',
      setDateRange: 'report/setDateRange',
      setTags: 'report/setTags',
      setTagAll: 'report/setTagAll',
      setWarehouses: 'report/setWarehouses',
      setWarehoueAll: 'report/setWarehoueAll',

      setIncludeCost: 'report/setIncludeCost'
    })
  }
}
</script>

<style lang="scss" scoped>
.note {
  margin-left: 18px;
  font-size: 12px;
  color: #9b9b9b
}
</style>
